import { render, staticRenderFns } from "./SpecialBonusModal.vue?vue&type=template&id=4671128c&"
import script from "./SpecialBonusModal.vue?vue&type=script&lang=js&"
export * from "./SpecialBonusModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports